/**
 * "Voorbeeld-workspace maken": een nieuwe workspace met het Meridiaan
 * Bank-model uit `examples/meridiaan-bank.json` (door vite meegeleverd onder
 * `/examples/`). Gewoon de bestaande routes: workspace aanmaken, dan de
 * JSON-import in de main-branch van het Default-workpackage. De import maakt
 * eerst een veiligheids-snapshot en zet de importeur als eigenaar.
 */
import { api, type ImportResultDTO } from "../api/client";

export const EXAMPLE_PATH = "/examples/meridiaan-bank.json";

export async function createExampleWorkspace(
  name: string,
  language: "nl" | "en",
): Promise<{
  workspaceId: string;
  workpackageId: string;
  branchId: string;
  result: ImportResultDTO;
}> {
  const res = await fetch(EXAMPLE_PATH);
  if (!res.ok) throw new Error(`${EXAMPLE_PATH}: HTTP ${res.status}`);
  const example: unknown = await res.json();

  const ws = await api.createWorkspace({ name, default_language: language });
  const { workpackages } = await api.listWorkpackages(ws.id);
  const branchId = workpackages.find((w) => w.id === ws.default_workpackage_id)?.mainBranchId;
  if (!branchId) throw new Error(`Workspace ${ws.id}: Default workpackage has no main branch`);
  const result = await api.importWorkspace(ws.id, branchId, example);
  return { workspaceId: ws.id, workpackageId: ws.default_workpackage_id, branchId, result };
}
